const getPercentageDiscountPrice = ({ price, percentageDiscount }) => {
  let newPrice = price;
  if (percentageDiscount) {
    newPrice = price - price * (percentageDiscount / 100);
  }
  return parseFloat(newPrice).toFixed(2);
};

export default getPercentageDiscountPrice;
